import { connect } from 'react-redux';
import passkeyManagementDrawer from 'store/app/ui/drawers/passkeyManagement/action';
import authCompany from 'store/selectors/authCompany';
import authEmployee from 'store/selectors/authEmployee';

const mapStateToProps = state => {
  const drawerState = state.drawers?.passkeyManagement || {};
  const employeeFromDrawer = drawerState.employeeId ? { _id: drawerState.employeeId } : null;

  return {
    open: drawerState.isOpen || false,
    company: authCompany(state),
    employee: employeeFromDrawer || authEmployee(state),
    isMe: !employeeFromDrawer,
  };
};

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(passkeyManagementDrawer.close()),
});

export default connect(mapStateToProps, mapDispatchToProps);
